import _Vue, { PluginFunction } from "vue";

// Use of relative paths to avoid conflict in path aliases in projects where
// this repository is used as a dependency

import "../../styles/main.scss";

// Audio
import JzMic from "../../components/audio/JzMic.vue";
import JzMicController from "../../components/audio/JzMicController.vue";
import JzMicTextBox from "../../components/audio/JzMicTextBox.vue";
// Chat
import JzChatContainer from "../../components/chat/JzChatContainer.vue";
import JzChatDictationAnswer from "../../components/chat/JzChatDictationAnswer.vue";
import JzChatDictationReview from "../../components/chat/JzChatDictationReview.vue";
import JzChatHint from "../../components/chat/JzChatHint.vue";
import JzChatImg from "../../components/chat/JzChatImg.vue";
import JzChatImgTimer from "../../components/chat/JzChatImgTimer.vue";
import JzChatImgTimerDialog from "../../components/chat/JzChatImgTimerDialog.vue";
import JzChatMsg from "../../components/chat/JzChatMsg.vue";
import JzChatSeparator from "../../components/chat/JzChatSeparator.vue";

// Control
import JzButton from "../../components/control/JzButton.vue";
import JzDictationDisplay from "../../components/control/JzDictationDisplay.vue";
import JzDictationInput from "../../components/control/JzDictationInput.vue";
import JzDictationOptions from "../../components/control/JzDictationOptions.vue";
import JzDemoConvController from "../../components/control/JzDemoConvController.vue";
import JzDropdownButton from "../../components/control/JzDropdownButton.vue";
import JzHamburger from "../../components/control/JzHamburger.vue";
import JzInput from "../../components/control/JzInput.vue";
import JzInputDropdown from "../../components/control/JzInputDropdown.vue";
import JzInputRadio from "../../components/control/JzInputRadio.vue";
import JzInputRadioGroup from "../../components/control/JzInputRadioGroup.vue";
import JzInputSelect from "../../components/control/JzInputSelect.vue";
import JzInputSlider from "../../components/control/JzInputSlider.vue";
import JzFilterButton from "../../components/control/JzFilterButton.vue";

// Drill
import JzDrillAnswerAreaCard from "../../components/drill/JzDrillAnswerAreaCard.vue";
import JzDrillBrowser from "../../components/drill/JzDrillBrowser.vue";
import JzDrillLearnStatus from "../../components/drill/JzDrillLearnStatus.vue";
import JzDrillProgressBar from "../../components/drill/JzDrillProgressBar.vue";
import JzMultipleChoiceQuestion from "../../components/drill/JzMultipleChoiceQuestion.vue";

// Feedback
import JzSpinner from "../../components/feedback/JzSpinner.vue";
import JzTimerBar from "../../components/feedback/JzTimerBar.vue";

// Image
import JzIcon from "../../components/image/JzIcon.vue";
import JzIconCorrect from "../../components/image/JzIconCorrect.vue";
import JzIconIncorrect from "../../components/image/JzIconIncorrect.vue";

// Layout
import JzButtonGroup from "../../components/layout/JzButtonGroup.vue";
import JzContainer from "../../components/layout/JzContainer.vue";
import JzFlexSpacer from "../../components/layout/JzFlexSpacer.vue";
import JzList from "../../components/layout/JzList.vue";
import JzListItem from "../../components/layout/JzListItem.vue";
import JzListSeparator from "../../components/layout/JzListSeparator.vue";
import JzTab from "../../components/layout/JzTab.vue";
import JzTabs from "../../components/layout/JzTabs.vue";

// Panel
import JzCard from "../../components/panel/JzCard.vue";
import JzModal from "../../components/panel/JzModal.vue";
import JzTitle from "../../components/panel/JzTitle.vue";
import JzTooltip from "../../components/panel/JzTooltip.vue";

// Typography
import JzTextDescription from "../../components/typography/JzTextDescription.vue";
import JzTextIpa from "../../components/typography/JzTextIpa.vue";

type JzComponentsPlugin = PluginFunction<any>;

/**
 * JzComponent plugin registers as global components a given list of components
 *
 * TODO: automatic registration of all components?
 */
const jzComponentsPlugin: JzComponentsPlugin = (Vue: typeof _Vue): void => {
	// Audio
	Vue.component("jz-mic", JzMic);
	Vue.component("jz-mic-controller", JzMicController);
	Vue.component("jz-mic-text-box", JzMicTextBox);
	// Chat
	Vue.component("jz-chat-container", JzChatContainer)
	Vue.component("jz-chat-dictation-answer", JzChatDictationAnswer)
	Vue.component("jz-chat-dictation-review", JzChatDictationReview)
	Vue.component("jz-chat-hint", JzChatHint)
	Vue.component("jz-chat-img", JzChatImg)
	Vue.component("jz-chat-img-timer", JzChatImgTimer)
	Vue.component("jz-chat-msg", JzChatMsg)
	Vue.component("jz-chat-separator", JzChatSeparator)
	Vue.component("jz-chat-msg-image", JzChatImg) // Kept for backward compatibility
	Vue.component("jz-chat-img-pb-dialog", JzChatImgTimerDialog) // Kept for backward compatibility
	Vue.component("jz-chat-img-pb-msg", JzChatImgTimer) // Kept for backward compatibility
	// Control
	Vue.component("jz-button", JzButton);
	Vue.component("jz-dictation-display", JzDictationDisplay);
	Vue.component("jz-dictation-input", JzDictationInput);
	Vue.component("jz-dictation-options", JzDictationOptions);
	Vue.component("jz-demo-conv-controller", JzDemoConvController);
	Vue.component("jz-dropdown-button", JzDropdownButton);
	Vue.component("jz-hamburger", JzHamburger);
	Vue.component("jz-input", JzInput);
	Vue.component("jz-input-dropdown", JzInputDropdown);
	Vue.component("jz-input-radio", JzInputRadio);
	Vue.component("jz-input-radio-group", JzInputRadioGroup);
	Vue.component("jz-input-select", JzInputSelect);
	Vue.component("jz-input-slider", JzInputSlider);
	Vue.component("jz-filter-button", JzFilterButton);
	// Drill
	Vue.component("jz-drill-answer-area-card", JzDrillAnswerAreaCard);
	Vue.component("jz-drill-browser", JzDrillBrowser);
	Vue.component("jz-drill-learn-status", JzDrillLearnStatus);
	Vue.component("jz-drill-progress-bar", JzDrillProgressBar);
	Vue.component("jz-multiple-choice-question", JzMultipleChoiceQuestion);
	// Feedback
	Vue.component("jz-spinner", JzSpinner);
	Vue.component("jz-timer-bar", JzTimerBar);
	// Image
	Vue.component("jz-icon", JzIcon);
	Vue.component("jz-icon-correct", JzIconCorrect);
	Vue.component("jz-icon-incorrect", JzIconIncorrect);
	// Layout
	Vue.component("jz-button-group", JzButtonGroup);
	Vue.component("jz-container", JzContainer);
	Vue.component("jz-flex-spacer", JzFlexSpacer);
	Vue.component("jz-list", JzList);
	Vue.component("jz-list-item", JzListItem);
	Vue.component("jz-list-separator", JzListSeparator);
	Vue.component("jz-tab", JzTab);
	Vue.component("jz-tabs", JzTabs);
	// Panel
	Vue.component("jz-card", JzCard);
	Vue.component("jz-modal", JzModal);
	Vue.component("jz-title", JzTitle);
	Vue.component("jz-tooltip", JzTooltip);
	// Typography
	Vue.component("jz-text-description", JzTextDescription);
	Vue.component("jz-text-ipa", JzTextIpa)
};

export default jzComponentsPlugin;
